
<div class="fixed-bottom d-flex justify-content-between" [ngStyle]="UIUtilityService.useSystemStyle() ? UIUtilityService.getBankButtonStyle() : UIUtilityService.getCustomizedButtonStyle()" [ngClass]="UIUtilityService.returnIfTrue(PlatformService.isIOS(), 'pb-4')">
  <div class="item-center" *ngFor="let item of this.itemList" [ngClass]="itemClass">
    <button mat-button (click)="item.action()" class="h-auto py-1">
      <div class="h-100 d-flex flex-column align-items-center">
        <div class="item-center">
          <img [src]="item.imgSrc" class="img-icon-35" [alt]="item.imgAlt">
        </div>
        <div class="font-bottom-bar-items">
          {{item.label| translate}}
        </div>
      </div>
    </button>
  </div>
</div>